import React from "react";

import { BackgroundOption, CustomCropper, CustomUpload } from "./components";

import { useStep } from "../../hooks";

const STEPS = [CustomUpload, CustomCropper, BackgroundOption];

function DeviceUpload({
  isGallery = false,
  logo_url,
  getTexture,
  handleUrls,
  cropped_url,
  isBgRemoved,
  bgRemovedUrl,
  showedBgRemovedUrl,
  setImageDimenstions,
  handleCustomizationDetails,
}) {
  const { deviceStep } = useStep();
  const Component = STEPS?.[deviceStep] || (() => null);

  return (
    <div className="device-upload">
      <Component
        isGallery={isGallery}
        logo_url={logo_url}
        getTexture={getTexture}
        handleUrls={handleUrls}
        cropped_url={cropped_url}
        isBgRemoved={isBgRemoved}
        bgRemovedUrl={bgRemovedUrl}
        showedBgRemovedUrl={showedBgRemovedUrl}
        setImageDimenstions={setImageDimenstions}
        handleCustomizationDetails={handleCustomizationDetails}
      />
    </div>
  );
}

export default DeviceUpload;
